import React, { useState, useRef, useEffect } from 'react';
import { useNetwork, NETWORKS, NetworkType } from '../contexts/NetworkContext';
import '../styles/NetworkSelector.css';

const NetworkSelector: React.FC = () => {
  const { selectedNetwork, setSelectedNetwork, networkConfig } = useNetwork();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleNetworkChange = (network: NetworkType) => {
    setSelectedNetwork(network);
    setIsOpen(false);
  };

  return (
    <div className="network-selector" ref={dropdownRef}>
      <button
        className="network-selector-button"
        onClick={() => setIsOpen(!isOpen)}
        style={{ borderColor: networkConfig.color }}
      >
        <img 
          src={networkConfig.icon} 
          alt={networkConfig.name}
          className="network-icon-img"
        />
        <span className="network-name">{networkConfig.name}</span>
        <span className="dropdown-arrow">{isOpen ? '▲' : '▼'}</span>
      </button>

      {isOpen && (
        <div className="network-dropdown">
          {Object.values(NETWORKS).map((network) => (
            <button
              key={network.id}
              className={`network-option ${selectedNetwork === network.id ? 'active' : ''}`}
              onClick={() => handleNetworkChange(network.id)}
              style={{
                borderLeftColor: network.color,
              }}
            >
              <img 
                src={network.icon} 
                alt={network.name}
                className="network-icon-img"
              />
              <span className="network-name">{network.name}</span>
              {selectedNetwork === network.id && (
                <span className="check-mark">✓</span>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default NetworkSelector;

